/**
 * bootstrap
 * 初始化处理和兼容性相关的模块动态加载
 * Optimized for conditional loading and bundle size reduction
 *
 * Created by Samuel on 2022/6/10
 */
import { lazyMotion } from "@motion";
import { proxyDefined } from "@core/utils/clientState";
import UADetect from "@core/utils/UADetect";

// Conditional IntersectionObserver polyfill
const loadIntersectionObserver = async () => {
  if (!window.IntersectionObserver) {
    await import("intersection-observer");
  }
};

export const bootstrap = async () => {
  const polyfills = [];

  // Load IntersectionObserver polyfill if needed
  polyfills.push(loadIntersectionObserver());

  const isIllegalChrome =
    UADetect.browser.chrome && UADetect.browser.version.split(".")[0] < 81;
  const isIllegalSafari =
    UADetect.browser.safari && UADetect.browser.version.split(".")[0] < 13;
  const isIllegalFirefox =
    UADetect.browser.firefox && UADetect.browser.version.split(".")[0] < 100;

  // Only load motion library for modern browsers that support Proxy
  if (
    proxyDefined &&
    !isIllegalChrome &&
    !isIllegalSafari &&
    !isIllegalFirefox
  ) {
    polyfills.push(lazyMotion());
  }

  // Wait for all polyfills and initializations to complete
  await Promise.all(polyfills);
};
